import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Anuluj zamówienie',
  title: 'Nigdy nie odrzucaj pochopnie!',
  text: 'Jeśli jest drobny problem z zamówieniem, zadzwoń do klienta i rozwiąż go.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Brak produktów',
    [OrderRejectionReason.ClosingSoon]: 'Lokal jest zamknięty',
    [OrderRejectionReason.StoryBusy]: 'Lokal jest zbyt zajęty',
    [OrderRejectionReason.CustomerMistake]: 'Klient zadzwonił, aby anulować',
    [OrderRejectionReason.DriverNotArrived]: 'Kierowca nie przybył',
  },
  buttons: {
    confirm: 'Potwierdź',
  },
};
